// @owners { team: patients }
import { COLORS } from '@alto/design-library-tokens';
import { Column, MdPadding, Row, XxxxlSpacing } from '@alto/design-system';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import logoAlto from '~shared/assets/images/altoLogo@2x.png';
import { PrefsConfirmationPage } from './PrefsConfirmationPage';
import { SubscriptionOptions } from './SubscriptionOptions';

const LogoContainer = styled.a`
  width: 106px;
`;

const AltoLogo = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

type RouteParams = {
  readonly uuid: string;
};

export const SubscriptionsPage = () => {
  const { uuid = '' } = useParams<RouteParams>();
  const [isUpdated, setIsUpdated] = useState(false);

  return (
    <Column
      flexShrink={0}
      flexGrow={1}
      centerHorizontally
      backgroundColor={COLORS.BACKGROUND_COLORS.WHITE}
    >
      <Row center>
        <MdPadding>
          <LogoContainer
            href="https://alto.com"
            aria-label="Alto Logo"
          >
            <AltoLogo src={logoAlto} />
          </LogoContainer>
        </MdPadding>
      </Row>
      <XxxxlSpacing />
      {isUpdated ? (
        <PrefsConfirmationPage />
      ) : (
        <SubscriptionOptions
          setIsUpdated={setIsUpdated}
          uuid={uuid}
        />
      )}
    </Column>
  );
};
